export default "/images/vendor/flag-icons/flags/4x3/bm.svg?8621f87bdecfd16a438347fc9b8839c3";